import { observer } from "mobx-react-lite";

import { useEditActionModalState } from "./edit-modal.state";
import { EditActionModalView } from "./edit-modal.view";

export const EditActionModal = observer(() => {
  const state = useEditActionModalState();
  return <EditActionModalView state={state} />;
});
